import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { CommandDialog, CommandEmpty, CommandInput, CommandList, cn } from '@clarix/ui';

/**
 * Visual shell of clario-frontend's CommandPalette. Renders the search
 * trigger in the topbar and a Cmd+K dialog with an empty state. Real
 * command registration ships later as features port.
 */
export function SearchPaletteShell() {
  const [open, setOpen] = useState(false);
  const isMac =
    typeof navigator !== 'undefined' && navigator.platform.toLowerCase().includes('mac');
  const shortcut = isMac ? '⌘K' : 'Ctrl+K';

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((p) => !p);
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={cn(
          'border-border bg-muted/40 flex h-8 w-full items-center gap-2 rounded-lg border px-3',
          // `hover:bg-muted` (gray-100), NOT `hover:bg-accent`: SidebarRail
          // re-points `--accent` at the user's sidebar palette (indigo by
          // default), which tinted this neutral chrome control on hover.
          'text-muted-foreground hover:bg-muted hover:text-foreground text-[12.5px] transition-colors',
        )}
        aria-label="Open search"
      >
        <Search className="h-3.5 w-3.5" strokeWidth={1.5} />
        <span className="flex-1 text-left">Search…</span>
        <kbd className="border-border bg-background text-muted-foreground ml-1.5 rounded border px-1 py-0.5 text-xs">
          {shortcut}
        </kbd>
      </button>

      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Search…" />
        <CommandList>
          <CommandEmpty>Search coming soon — feature registration lands later.</CommandEmpty>
        </CommandList>
      </CommandDialog>
    </>
  );
}
